import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import GrantedPopup from "../../../components/SearchComponent/NewComponents/GrantedPopup/GrantedPopup";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import FavoriteNoResult from "./FavoriteNoResult/FavoriteNoResult";
import stl from "./UserFavoriteComponents.module.css";
import { useTranslation } from "@i18n";
import DeskTopBlueMobileWhiteHeader from "../../../components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import useHelpers from "@hooks/useHelpers";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import useIsMobile from "@hooks/useIsMobile";
import useKeyPressSwitch from "@hooks/useKeyPressSwitch";
import ToggleCarCompare from "@/_MiniApps/CarCompare/Components/ToggleCarCompare";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var UserFavoriteComponents = function UserFavoriteComponents(_ref) {
  var posts = _ref.posts;
  var _useTranslation = useTranslation(["web_favorite", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useCarCompareContext = useCarCompareContext(),
    hasCarsToCompare = _useCarCompareContext.hasCarsToCompare;
  var _useState = useState(false),
    showGrantedPopup = _useState[0],
    setShowGrantedPopup = _useState[1];
  var isMobile = useIsMobile();
  var _useState2 = useState(false),
    showOldCard = _useState2[0],
    setShowOldCard = _useState2[1];
  var handleKeyPressSwitch = function handleKeyPressSwitch() {
    setShowOldCard(!showOldCard);
  };
  useKeyPressSwitch(handleKeyPressSwitch);
  return /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    title: t("favorite_cars", {
      ns: "web_tracking"
    }),
    hasDeskTopBack: true,
    onClick: function onClick() {
      return navigateTo("/user/account");
    },
    customBackground: stl.favPageBG,
    showToggle: (posts === null || posts === void 0 ? void 0 : posts.length) > 0 || true
  }), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "max-w-full px-4 mx-auto mb-[-24px]"
  }, /*#__PURE__*/React.createElement(ToggleCarCompare, {
    labelText: t("car_comparison", {
      ns: "web_tracking"
    })
  })), !(posts !== null && posts !== void 0 && posts.length) && /*#__PURE__*/React.createElement("div", {
    className: stl.noDataContainer
  }, /*#__PURE__*/React.createElement(FavoriteNoResult, null)), /*#__PURE__*/React.createElement("section", {
    className: "max-w-full px-4 mx-auto lg:max-w-[992px] xl:max-w-[1130px] 2xl:max-w-[1330px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.cardsWrapper, "  ")
  }, posts === null || posts === void 0 ? void 0 : posts.map(function (post, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: i + 1,
      key: i,
      showGrantedPopup: function showGrantedPopup() {
        return setShowGrantedPopup(true);
      },
      page: "favorite",
      sectionType: "favorite"
    }));
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showGrantedPopup,
    onClose: function onClose() {
      return setShowGrantedPopup(false);
    }
  }, /*#__PURE__*/React.createElement(GrantedPopup, null)));
};
export default UserFavoriteComponents;